import { useReducer } from 'react';
function toggleReducer(state, nextValue) {
  return typeof nextValue === 'boolean' ? nextValue : !state;
}
export function useToggle() {
  let initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return useReducer(toggleReducer, initialValue);
}